import { ASYNC_STATE } from "assets/scripts/constants/Constants";
import { createReducer } from "redux-create-reducer";
import { DOCUMENT_ACTIONS } from "assets/scripts/domain/document/documentActions";
const INITIAL_STATE = {
    loadState: ASYNC_STATE.NONE,
    loadError: null,
    documents: [],
    documentTypes: [],
    addModalOpen: false,
    addState: ASYNC_STATE.NONE,
    addError: null,
    backendErrors: {
        globalError: null,
        backendErrors: {}
    }
};
export default createReducer(INITIAL_STATE, {
    [DOCUMENT_ACTIONS.LOAD_DOCUMENTS_STARTED](state, _action) {
        const { documents, documentTypes, loadError } = INITIAL_STATE;
        return {
            ...state,
            loadState: ASYNC_STATE.PENDING,
            documents,
            documentTypes,
            loadError
        };
    },
    [DOCUMENT_ACTIONS.LOAD_DOCUMENTS_SUCCEEDED](state, { payload }) {
        const { documents, documentTypes } = payload;
        return {
            ...state,
            loadState: ASYNC_STATE.RESOLVED,
            documents,
            documentTypes,
            loadError: null
        };
    },
    [DOCUMENT_ACTIONS.LOAD_DOCUMENTS_FAILED](state, { payload }) {
        return {
            ...state,
            loadState: ASYNC_STATE.REJECTED,
            loadError: payload
        };
    },
    [DOCUMENT_ACTIONS.ADD_MODAL_CHANGE](state, { payload }) {
        let newState = {
            ...state,
            addModalOpen: payload
        };
        if (payload) {
            newState = {
                ...newState,
                addState: ASYNC_STATE.NONE,
                addError: null,
                backendErrors: INITIAL_STATE.backendErrors
            };
        }
        else if (state.addState === ASYNC_STATE.PENDING) {
            // prevent modal close while saving
            return state;
        }
        return newState;
    },
    [DOCUMENT_ACTIONS.ADD_DOCUMENT_STARTED](state, _action) {
        return {
            ...state,
            addState: ASYNC_STATE.PENDING,
            addError: null
        };
    },
    [DOCUMENT_ACTIONS.ADD_DOCUMENT_SUCCEEDED_TRUE](state, { payload }) {
        return {
            ...state,
            addState: ASYNC_STATE.RESOLVED,
            documents: [...state.documents, payload],
            backendErrors: INITIAL_STATE.backendErrors,
            addModalOpen: false
        };
    },
    [DOCUMENT_ACTIONS.ADD_DOCUMENT_SUCCEEDED_FALSE](state, { payload }) {
        return {
            ...state,
            addState: ASYNC_STATE.RESOLVED,
            backendErrors: payload
        };
    },
    [DOCUMENT_ACTIONS.ADD_DOCUMENT_FAILED](state, { payload }) {
        return {
            ...state,
            addState: ASYNC_STATE.REJECTED,
            addError: payload
        };
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/document/documentReducer.ts